import React from 'react';
import VerifyWrapper from "../../components/verifyWrapper";
import Login from "../../components/login";
import { motion } from 'framer-motion';
import {FormCardTransition, FormCardVariants} from "styles/styled";
import useDocumentTitle from "../../util/hooks/useDocumentTitle";

const LoginPage = () => {

  useDocumentTitle('Login');

  return (
    <motion.div
      initial="out"
      animate="in"
      exit="out"
      transition={FormCardTransition}
      variants={FormCardVariants}
    >
      <VerifyWrapper>
        <Login/>
      </VerifyWrapper>
    </motion.div>

  )
}

export default LoginPage;
